export const DOCUMENT_NUMBER_REGEX = /[\s/\-/]/g;
export const trimInvalidCharactersFromDocumentNumber = (value: string): string => {
  if (value.match(DOCUMENT_NUMBER_REGEX)) {
    return value.replace(DOCUMENT_NUMBER_REGEX, '');
  }
  return value;
};



// WEBPACK FOOTER //
// ./src/utils/document-number-checks.ts